import {
  ComponentType,
  ReactNode,
  createContext,
  useContext,
  useMemo,
  useState,
} from "react";

const Context = createContext<
  React.Dispatch<React.SetStateAction<ReactNode | null>>
>(() => {});

export function inPopuper<P>(Component: ComponentType<P>) {
  return function Wapper(props: JSX.IntrinsicAttributes & P) {
    const [popup, setPopup] = useState<ReactNode>();
    return (
      <Context.Provider value={setPopup}>
        {useMemo(
          () => (
            <Component {...props} />
          ),
          [Component, props],
        )}
        {popup}
      </Context.Provider>
    );
  };
}
export default function usePopuper() {
  return useContext(Context);
}
